<template>
    <div class="headerNavVue margin-right">

    <header v-if="userRoleSlug == 'client-admin' || userRoleSlug == 'power-user' || userRoleSlug == 'employee' || userRoleSlug =='auditor'" class="o-header">
        <div class="col-md-5 text-left">
        
                <label class="client-name-align-style">{{getSubdomain}}</label>
            
            
            <label class="table-td-border-left" v-if="userRoleSlug == 'client-admin' || userRoleSlug == 'power-user' || userRoleSlug =='auditor'">
                <span class="o-blue-regular-text">{{ $t('active_employees') }}:</span>
                <span>{{noOfActiveEmployee}}</span>
            </label>
            <br />
            <label class="pl-10 pointer ml-60" v-if="userRoleSlug == 'client-admin'||userRoleSlug == 'power-user'" @click="gotoSmsLog">
                <span class="o-blue-regular-text new-line-padding">Monthly SMS Sent:</span>
                <span>{{ smsCount }} X 0.0085=${{ (smsCount * 0.0085).toFixed(2) }}</span>
            </label>
            <!-- <label class="pl-10 pointer active-button" v-if="userRoleSlug == 'client-admin'" @click="getClientSMSLogs">
                <span class="active"> Pull SMS Count </span> login.callsteward.com
            </label> -->
        </div>
        <div class="col-md-7">
            
            <ul class="o-header-nav">
                 <!-- <li>
                    <div class="dropdown o-profile-drop">
                            <button class="btn btn-secondary dropdown-toggle o-profile-dropdownlist" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <span class="o-logged-user-name">{{ $t('language') }}</span> <i class="fa fa-angle-down" aria-hidden="true"></i>
                            </button>
                            <div class="dropdown-menu dropdown-menu-right profile-drop-menu" aria-labelledby="dropdownMenuButton">
                                <ul class="">
                                    <li v-for="(lang,index) in preferedLanguages" :key="index" @click="changeLanguage(lang)">
                                        <a href="javascript: void(0)" class="nav-link">{{ $t(lang.label) }}</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                </li> -->
                <!-- <li ><router-link :to="'/empoyerProfile/'+getId()" @click="myProfileEmployer()" class="dropdown-item">My Profile</router-link></li> -->
                <li v-if="userRoleSlug!='client-admin' && switchClientAccess">
                    <router-link to="/switchClient" @click="goToSwitchClient()" class="c-link"><i class="fa fa-cog" aria-hidden="true"></i>
                    {{ $t('change_local') }}</router-link>
                </li>
                <li v-if="getPower('emp-merge')">
                    <a href="javascript: void(0)" @click="goAdminEmployeesMerge()" class="c-link"> <i class="fa fa-users" aria-hidden="true"></i> 
                    {{ $t('employee_merger') }} </a>
                </li>
                <li v-if="getPower('config')">
                    <router-link to="/configuration" @click="goToConfig()" class="c-link"><i class="fa fa-cog" aria-hidden="true"></i> {{ $t('configuration') }}</router-link>
                </li>
                <li>
                    <router-link to="/myProfile" @click="myProfile()" class="c-link"><i class="fa fa-user" aria-hidden="true"></i> {{ $t('my_profile') }}</router-link>
                </li>

                <!-- <li>
                    <a href="#" class="c-link o-notify-bell"><i class="fa fa-bell-o" aria-hidden="true"></i><span class="o-notify-badge">34</span></a>
                </li> -->

                <li class="mr-5">
                    <div class="o-logged-user-area">
                        <div class="o-post-logged">
                            <span class="o-user-profile-img o-header-profile-pic">
                                <img v-if="userImage != '' && userImage != 'NULL'" :src="(userImage)" />
                                <img v-if="userImage == '' || userImage == 'NULL'" src="static/assets/images/user1.png" />
                            </span> {{ $t('welcome') }}
                        </div>
                        <div class="dropdown o-profile-drop">
                            <button class="dropdown-toggle o-profile-dropdownlist" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" @click="toggleDropdown">
                                <span class="o-logged-user-name">{{this.userFirstName}}</span> 
                                <i class="fa fa-angle-down" aria-hidden="true"></i>
                            </button>
                            <div class="dropdown-menu dropdown-menu-right profile-drop-menu" :class="{ 'show': isDropdownVisible }" aria-labelledby="dropdownMenuButton">
                                <ul class="">
                                   <!--  <li ><router-link to="/myProfile" @click="myProfile()" class="dropdown-item">My Profile</router-link></li> -->
                                    <li @click="logoutUser()">
                                        <a href="javascript: void(0)" class="nav-link">{{ $t('logout') }}</a>
                                    </li>

                                </ul>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </header>
    <header v-else-if="userRoleSlug == 'employer-admin' || userRoleSlug == 'employer'" class="o-header">
        <div class="col-md-12">
            <ul class="o-header-nav">
               
                <li>
                    <router-link to="/companyInfo" @click="myCompanyEmployer()" class="c-link"><i class="fa fa-briefcase" aria-hidden="true"></i>Company profile</router-link>
                </li>
                <li>
                    <router-link :to="'/empoyerProfile/'+getId()" @click="myProfileEmployer()" class="c-link"><i class="fa fa-user" aria-hidden="true"></i> My profile </router-link>
                </li>
                
                <!-- <li>
                    <a href="#" class="c-link o-notify-bell"><i class="fa fa-bell-o" aria-hidden="true"></i><span class="o-notify-badge">34</span></a>
                </li> -->

                <li>
                    <div class="o-logged-user-area">
                        <div class="o-post-logged">
                            <span class="o-user-profile-img o-header-profile-pic">
                                <img v-if="userImage != '' && userImage != 'NULL'" :src="(userImage)" />
                                <img v-if="userImage == '' || userImage == 'NULL'" src="static/assets/images/user1.png" />
                            </span> Welcome
                        </div>
                        <div class="dropdown o-profile-drop">
                            <button class="btn btn-secondary dropdown-toggle o-profile-dropdownlist" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" @click="toggleDropdown">
                                <span class="o-logged-user-name">{{this.userFirstName}}</span> 
                                <i class="fa fa-angle-down" aria-hidden="true"></i>
                            </button>
                            <div class="dropdown-menu dropdown-menu-right profile-drop-menu" :class="{ 'show': isDropdownVisible }" aria-labelledby="dropdownMenuButton">
                                <ul class="">
                                    <!-- <li ><router-link :to="'/empoyerProfile/'+getId()" @click="myProfileEmployer()" class="dropdown-item">My Profile</router-link></li> -->
                                    <li @click="logoutUser()"><a href="javascript: void(0)" class="nav-link">{{ $t('logout') }}</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </header>
    <header v-else-if="userRoleSlug == 'super-admin'" class="o-super-header">
        <div class="col-md-12 o-left-no-padding">
            <ul class="o-header-nav o-super-header-left">
                <li class="o-super-logo-area">
                    <a href="javascript: void(0)" @click="goToClientList()" class="o-admin-logo">
                        <img src="static/assets/images/logo.png"/>
                    </a>
                </li>
                <li class="o-super-header-link text-left">
                    <a href="javascript: void(0)" @click="goToClientList()" class="c-link">
                        <i class="fa fa-home" aria-hidden="true"></i> 
                        Dashboard
                    </a>
                    <br />
                    <a href="javascript: void(0)" @click="goAdminEmployersMerge()" class="c-link"> 
                        <i class="fa fa-users" aria-hidden="true"></i>
                        Employer Merger
                    </a>
                </li>
                <li class="o-super-header-link">
                    <a href="javascript: void(0)" @click="goToEmployer()" class="c-link"><i class="fa fa-user" aria-hidden="true"></i> Employers</a>
                </li>
                <li class="o-super-header-link">
                    <a href="javascript: void(0)" @click="goToEmployee()" class="c-link"><i class="fa fa-users" aria-hidden="true"></i> Employees</a>
                </li>
                <li class="o-super-header-link">
                    <a href="javascript: void(0)" @click="goSendNotic()" class="c-link"><i class="fa fa-envelope" aria-hidden="true"></i> Send Notice</a>
                </li>
                <li class="o-super-header-link">
                    <a href="javascript: void(0)" @click="goToReports()" class="c-link"><i class="fa fa-file-o" aria-hidden="true"></i> Reports</a>
                </li>
                <li class="o-super-header-link">
                    <!-- <a @click="goTinyUrl()" class="c-link"><i class="fa fa-download"></i> Generate Tiny Url</a> -->
                    <a href="javascript: void(0)" @click="goAdminConfig()" class="c-link"><i class="fa fa-cog" aria-hidden="true"></i> Configuration</a>
                </li>
                <li class="o-super-header-link">
                    <a href="javascript: void(0)" @click="goAdminEmployeesMerge()" class="c-link"> <i class="fa fa-users" aria-hidden="true"></i> Employee Merger</a>
                </li>
                <!-- <li class="o-super-header-link">
                    <a href="javascript: void(0)" @click="goAdminEmployersMerge()" class="c-link"> <i class="fa fa-users" aria-hidden="true"></i> Employer Merger</a>
                </li> -->
                <!-- <li class="o-super-header-link">
                    <a @click="goTinyUrl()" class="c-link"><i class="fa fa-download"></i> Generate Tiny Url</a>
                </li> -->
            </ul>

            <ul class="o-header-nav o-super-header-right">
                <li>
                    <div class="o-logged-user-area">
                        <div class="o-post-logged">
                            <span class="o-user-profile-img">
                                <img src="static/assets/images/user3.png" />
                            </span> Welcome
                        </div>
                        <div class="dropdown o-profile-drop">
                            <button class="btn btn-secondary dropdown-toggle o-profile-dropdownlist" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" @click="toggleDropdown">
                                <span class="o-logged-user-name">
                                    Ed
                                </span> 
                            <i class="fa fa-angle-down" aria-hidden="true"></i>
                            </button>
                            <div class="dropdown-menu dropdown-menu-right profile-drop-menu" :class="{ 'show': isDropdownVisible }" aria-labelledby="dropdownMenuButton">
                                <ul class="">
                                    <li><a href="javascript: void(0)" @click="logoutUser()" class="nav-link">{{ $t('logout') }}</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>            
        </div>
    </header>
    <!-- v-if="userRoleSlug != 'super-admin' && userRoleSlug != 'client-admin' && userRoleSlug != 'power-user' && userRoleSlug != 'employee' && userRoleSlug != 'employer-admin' && userRoleSlug != 'employer' || userRoleSlug !='auditor'" -->
    <header v-else class="o-header">
        <div class="col-md-12">
            <ul class="o-header-nav">
                <li>
                    <div class="o-logged-user-area">
                        <div class="o-post-logged">
                            <span class="o-user-profile-img o-header-profile-pic">
                                <img v-if="userImage != '' && userImage != 'NULL'" :src="(userImage)" />
                                <img v-if="userImage == '' || userImage == 'NULL'" src="static/assets/images/user1.png" />
                            </span> Welcome
                        </div>
                        <div class="dropdown o-profile-drop">
                            <button class="btn btn-secondary dropdown-toggle o-profile-dropdownlist" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" @click="toggleDropdown">
                                <span class="o-logged-user-name">{{this.userFirstName}}</span> 
                                <i class="fa fa-angle-down" aria-hidden="true"></i>
                            </button>
                            <div class="dropdown-menu dropdown-menu-right profile-drop-menu" :class="{ 'show': isDropdownVisible }" aria-labelledby="dropdownMenuButton">
                                <ul class="">
                                    <li @click="logoutUser()"><a href="javascript: void(0)" class="nav-link">{{ $t('logout') }}</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </header>
  </div>
</template>
<script>
    import Vue from 'vue'
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import {
        global
    } from '../global.js';
    // import Vuei18n from '../lang/i18n.js'
    // import Vuei18n from 'vue-i18n'
    import dateTimeConvert from '../timeConvert&Compare';
    import service from '../services';
    // Vue.use(Vuei18n);
    export default {
        computed: {
            ...mapGetters({
                userFirstName: 'userFirstName',
                userFullName: 'userFullName',
                userImage: 'userImage',
                userRoleSlug: 'userRoleSlug',
                getSubdomain:'getSubdomain',
                employerUserId : 'employerUserId',
                userID: 'userID',
                userToken: 'userToken',
                userClientID:'userClientID',
                userEmail:'userEmail',
                userPhone:'userPhone',
                
            }),
            switchClientAccess(){
                if(this.clients && this.clients.length>1)
                    return true;
                return false;
            }
        },
        data() {
            return {
                smsLogs: [],
                smsCount: 0,
                imagePath: '',
                getBaseURL: '',
                clients:[],
                noOfActiveEmployee:null,
                preferedLanguages: [
                    {
                        label: 'English',
                        value: 'en'
                    },
                    {
                        label: 'Spanish',
                        value: 'sp'
                    },
                ],
                isDropdownVisible: false
                // polling: null
            }
        },
        methods: {
            // pollData () {   
            //     this.polling = setInterval(() => {
            //             if(document.visibilityState === 'visible'){
            //                 this.timerState = "Started"
            //             }else {
            //                 this.timerState = "Paused"
            //             }                
            //         if (this.timerState === "Started") {
            //             this.getClientSMSLogs();
            //         }
            //     }, 15*60000);
            // },
            toggleDropdown() {
                console.log("CHECK CHECK");
                this.isDropdownVisible = !this.isDropdownVisible;
            },
            closeDropdown() {
                this.isDropdownVisible = false;
            },

            getClientSMSLogs() {
                service.get('client/getBandwidthSMSCount', {
                    'Authorization': this.userToken,
                    'cs3-context-clientId': this.userClientID,
                }).then((res) => {
                    // this.smsLogs=res.data.result.messages;
                    this.smsCount=res.data.result?res.data.result:0;
                }).catch(err =>{
                    console.log(err);
                });
            },

            gotoSmsLog() {
                this.$router.push({
                    path: "/clientSMSLog",
                    name: "clientSMSLog"
                });
            },

            // changeLanguage(lang) {
            //     // console.log(lang.label);
            //     // console.log(lang.value);
            //     localStorage.setItem("lang", lang.value);
            //     localStorage.getItem("lang");
            //     location.reload();
            //     // this.$router.reload();
            // },
            getClientAssociationList(){
                service.get('employee/'+this.userID+'/getEmployeesAssociation', {
                    'Authorization': this.userToken
                }).then((res) => {
                    this.clients=res.data.result;
                }).catch(err =>{
                    console.log(err);
                });
            },
            getClientActiveUser(){
                service.get('employee/getActiveEmployeeCount', {
                    'Authorization': this.userToken,
                    'clientId': this.userClientID
                }).then((res) => {
                    // console.log('Active user list', res)
                    this.noOfActiveEmployee=res.data.result;
                }).catch(err =>{
                    console.log(err);
                });
            },
            getId(){
                return btoa(this.employerUserId)
            },
            goToReports(){
                this.$router.push({
                    path: "/admin-reports-configuration"
                });
            },
            goToSwitchClient(){
                this.$router.push({
                    path: "/switchClient"
                });  
            },
            goAdminConfig(){
                this.$router.push({
                    path: "/adminConfig"
                });
            },
            goAdminEmployeesMerge(){
                this.$router.push({
                    path: "/employeeMergerForm"
                });
            },
            goAdminEmployersMerge(){
                this.$router.push({
                    path: "/employerMergerForm"
                });
            },
            myProfileEmployer(){
                this.$router.push({
                    path: "/empoyerProfile/"+btoa(this.employerUserId)
                });
                //console.log('data',this.employerUserId);
            },
            myCompanyEmployer(){
                this.$router.push({
                    path: "/companyInfo"
                });
            },
            getPower(data) {
                //console.log('headernav',typeof dateTimeConvert.checkAccess(data));
                return dateTimeConvert.checkAccess(data);
            },
            logoutUser: function() {
                
                // remove chart icon.
                // window.fcWidget.init({
                //     token: "5f5b4092-cff9-4586-9c85-5d4c79365f71",
                //     host: "https://wchat.freshchat.com",
                //     config: {
                //       headerProperty: { 
                //         hideChatButton: true 
                //       } 
                //     }
                // });
                service.post('logout',{}, {
                    'Authorization': this.userToken
                    // 'clientId': this.userClientID
                }).then((res) => {
                    // console.log(res.data);
                    // if(res.data.status_code == '1') {
                        this.$notify({
                            title: res.data&&res.data.status_message?res.data.status_message:'Logout Successful',
                            message: '',
                            type: 'success'
                        });
                        // clear cookies & local data.
                        this.$cookies.remove("csLogin", "/mobile");
                        this.$cookies.remove("csLogin");
                        this.$cookies.remove("date_format");
                        this.$cookies.remove("time_format");
                        this.$cookies.remove("time_zone");
                        localStorage.removeItem('vuex');
                        this.$store.dispatch('setTokenExpiry', '');
                        localStorage.clear();
                        location.reload(true);
                        // this.$router.push({
                        //     path: "/login"
                        // });
                    // }
                }).catch(err =>{
                    console.log(err);
                    this.$notify({
                        title: 'Error',
                        message: err.response.data.message,
                        type: 'error'
                    });
                });

                // clear cookies & local data.
                // this.$cookies.remove("csLogin", "/mobile");
                // this.$cookies.remove("csLogin");
                // this.$cookies.remove("date_format");
                // this.$cookies.remove("time_format");
                // this.$cookies.remove("time_zone");
                // localStorage.removeItem('vuex');
                // this.$store.dispatch('setTokenExpiry', '');
                // localStorage.clear();
                // location.reload(true);
                
                // this.$router.push({
                //     path: "/login"
                // });
            },
            myProfile() {
                this.$router.push({
                    path: `/myProfile`
                });
            },
            goToConfig() {
                this.$router.push({
                    path: "/configuration"
                });
            },
            goToClientList() {
                this.$router.push({
                    path: "/clientList"
                });
            },
            goSendNotic() {
                this.$router.push({
                    path: "/clientSendNotice"
                });

            },
            goToEmployer(){
                this.$router.push({
                    path:'/clientEmployersList'
                });
            },
            goToEmployee(){
                this.$router.push({
                    path:'/adminEmployeeList'
                });
            },
            goTinyUrl(){
                this.$router.push({
                    path:'/tinyUrl'
                });
            },
            checkRouteName(name) {
                let result=false;
                switch(name) {
                    case 'jobDetails':
                    case 'ViewCalls':
                    case 'viewCallsEmployer':
                    case 'PhoneSheet':
                    case 'bulkAssignCustom':
                    case 'singleAssignCustom':
                        result = true;
                        break;
                    default:
                        result = false;
                }
                return result;            
            }

        },
        watch: {
            $route() {
                // console.log(this.$route.name);
                if(!this.checkRouteName(this.$route.name)) {
                    const titleEl = document.querySelector('head title');
                    titleEl.textContent = [this.getSubdomain+' | Call Steward'];
                }
            }
        },
        created() {            
            this.getBaseURL = global[0].IMAGE_URL;
            this.getClientActiveUser();
            const titleEl = document.querySelector('head title');
            titleEl.textContent = [this.getSubdomain+' | Call Steward'];
            // if(this.userRoleSlug == 'client-admin' && this.$route.path=='/jobList'){
            //     this.pollData();
            // }
        },
        mounted() {
            // $(this.$el).find('.dropdown-toggle').dropdown();
            document.addEventListener('click', (e) => {
                if (!this.$el.contains(e.target)) {
                    this.closeDropdown();
                }
            });
            var sidenavWidth = $(".mainSidenav").width();
            var windowWidth = $(window).width();
            $(".o-header").css('width', windowWidth - sidenavWidth);
            this.getClientAssociationList();
            if(this.userRoleSlug == 'client-admin'){
                this.getClientSMSLogs();
            }
        },
        // beforeMount() {
        //     localStorage.setItem("lang", 'en');
        // },
        updated() {
            var sidenavWidth = $(".mainSidenav").width();
            var windowWidth = $(window).width();
            $(".o-header").css('width', windowWidth - sidenavWidth);
        },
        beforeDestroy() {
            // clearInterval(this.polling);

        }
    }

</script>
<style scoped>
    /* .dropdown-menu {
        display: block !important;
        opacity: 1 !important;
        visibility: visible !important;
    } */
    .dropdown-menu {
        display: none;
    }

    .dropdown-menu.show {
        display: block;
    }
    .ml-60 {
        margin-left : 60px;
    }
    .active-button {
        background-color: #FB8B03;
        color: #FFFFFF;
        padding: 5px;
        margin-left: 5px;
        font-size: 12px;
    }
    .c-link .fa-briefcase {
        margin-right: 12px;
    }
    .text-left{
        text-align: left!important;
    }
    .ml-10 {
        margin-left: 10px;
        
    } 
    
    .margin-right { 
        margin-right: 10px!important;
    }

    a {
        cursor: pointer;
    }
    .pointer{
        cursor: pointer;
    }
    .client-name-align-style{
        text-align: left;
        padding-left: 40px;
        padding-top: 3px;
        font-size: 20px;
        margin-right: 5px;
    }
    .pl-10{
        padding-left: 10px;
    }
    ul.o-header-nav {
        display: inline-flex !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/headerNav.vue